import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

import { Link as LinkUnited } from '@olist/united';

export const Links = styled.section`
  background: #e9ebed;
  h3 {
    margin-bottom: 30px;
    text-align: center;
  }
  .content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;

export const Link = styled(LinkUnited)`
  background-color: #0c29d0;
  border: 1px solid #0c29d0;
  border-radius: ${themeGet('olist.borderRadius.pill')};
  color: #ffffff;
  display: flex;
  height: 48px;
  margin: 5px;
  padding: 0px 24px;
  &:hover {
    background-color: #0c29d0 !important;
    border: 1px solid #0c29d0 !important;
    box-shadow: none !important;
    color: #ffffff !important;
    svg {
      margin-left: 10px;
      width: 12px;
    }
  }
  svg {
    display: block;
    margin-left: 0px;
    overflow: hidden;
    transition: 0.3s;
    width: 0;
    path {
      fill: #ffffff !important;
    }
  }
  a {
    color: #ffffff;
    text-decoration: none;
  }
`;
